import { createContext } from "react"

const AccessEquipmentContext = createContext();

export default AccessEquipmentContext;